import DeadlineCountdown from '@/app/recommend-class/components/deadline-countdown';
import FullWidthSection from '@/components/full-width-section';
import ImageOptimizer from '@/components/image-optimizer';
import PoliceLineDivider from '@/components/police-line-divider';
import { UNLIMITED_CHANGE_PRICE_EFFECTIVE_DATE, isDateOver } from '@/lib/date';
import { formatKoreanCurrency } from '@/lib/utils';
import { getServerTime } from '@/services/base-api';
import { useUnlimited2WeeksMaxDiscountAmount } from '@/services/query/pricing.query';

export default function UnlimitedTopBanner() {
  const { data: maxDiscountAmountData } = useUnlimited2WeeksMaxDiscountAmount();
  const maxDiscountAmount = maxDiscountAmountData?.data ?? 150000;

  const isChangeUnlimitedPriceDateOver = isDateOver(
    getServerTime(),
    UNLIMITED_CHANGE_PRICE_EFFECTIVE_DATE,
  );

  return (
    <FullWidthSection>
      <div
        className="desktop:pt-[56px] desktop:pb-[72px] pt-[93px] pb-[101px]"
        style={{
          backgroundImage: `url('/images/recommend-class/unlimited/bg_main.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="desktop:flex desktop:items-center desktop:gap-8 flex flex-col items-center gap-7">
          {/* 데스크톱: 보임 / 모바일: 숨김 */}
          <div className="desktop:flex hidden">
            {isChangeUnlimitedPriceDateOver ? (
              <ImageOptimizer
                src="/images/recommend-class/unlimited/top_img_25.png"
                alt="banner"
                width={792}
                height={480}
              />
            ) : (
              <ImageOptimizer
                src="/images/recommend-class/unlimited/top_img.webp"
                alt="banner"
                width={792}
                height={480}
              />
            )}
          </div>
          {/* 데스크톱: 숨김 / 모바일: 보임 */}
          <div
            className={`desktop:hidden w-full ${isChangeUnlimitedPriceDateOver ? 'aspect-[100/89]' : ''}`}
          >
            {isChangeUnlimitedPriceDateOver ? (
              <ImageOptimizer
                src="/images/recommend-class/unlimited/top_img_25_m.png"
                alt="banner"
                width={792}
                height={480}
                priority
                className="h-full w-full object-cover object-center"
              />
            ) : (
              <ImageOptimizer
                src="/images/recommend-class/unlimited/top_img.webp"
                alt="banner"
                width={792}
                height={480}
              />
            )}
          </div>
          {/**웹 */}
          <div
            className={`desktop:flex typo-26 desktop:typo-40 hidden gap-2 font-extrabold text-black ${isChangeUnlimitedPriceDateOver ? 'mt-[-24px]' : ''}`}
          >
            <span className="text-main-orange">무제한 이용</span>으로
            <span className="text-main-orange">초단기</span> 끝내는 면허
          </div>
          {/** 모바일 */}
          <div
            className={`desktop:hidden typo-26 desktop:typo-28 flex flex-col items-center justify-center gap-2 font-extrabold text-black ${isChangeUnlimitedPriceDateOver ? 'mt-[-60px]' : ''}`}
          >
            <span>
              <span className="text-main-orange">무제한 이용</span>으로
            </span>
            <span>
              <span className="text-main-orange">초단기</span> 끝내는 면허
            </span>
          </div>
        </div>
      </div>

      {/* 시간 영역 */}
      <div className="desktop:pb-10 bg-main-yellow pb-5">
        {/**웹*/}
        <div className="desktop:block hidden shadow-lg">
          <PoliceLineDivider
            height={28}
            backgroundImage="url('/images/recommend-class/common/police_pattern.webp')"
            backgroundSize="auto 100%"
          />
        </div>
        {/**모바일*/}
        <div className="desktop:hidden block shadow-lg">
          <PoliceLineDivider
            height={16}
            backgroundImage="url('/images/recommend-class/common/police_pattern.webp')"
            backgroundSize="auto 100%"
          />
        </div>
        <div className="desktop:web-w desktop:pt-10 desktop:mx-auto desktop:gap-[18px] flex w-full flex-col items-center justify-center gap-[16px] pt-5">
          <DeadlineCountdown
            title={`최대 ${formatKoreanCurrency(maxDiscountAmount)} 할인 종료까지 남은 시간`}
          />
        </div>
      </div>
    </FullWidthSection>
  );
}
